import loadable from '@loadable/component'
import { useParams } from 'react-router'
import { useAppSelector } from 'hooks/reduxHooks'
import Route from 'components/App/Routes/TrackedRoute'
import LocaleAwareSwitch from 'components/App/Routes/LocaleAwareSwitch'
import { isCorporateEventsHostname } from './utils/corporateEventsRoutes'
import CorporateEventLayout from './components/CorporateEventLayout'

const CorporateEventLandingPage = loadable(
  () =>
    import(
      /* webpackChunkName: 'CorporateEventLandingPage' */ './pages/CorporateEventLandingPage'
    ),
)
const CorporateEventFAQPage = loadable(
  () =>
    import(
      /* webpackChunkName: 'CorporateEventFAQPage' */ './pages/CorporateEventFAQPage'
    ),
)
const CorporateEventOtherActivitiesPage = loadable(
  () =>
    import(
      /* webpackChunkName: 'CorporateEventOtherActivitiesPage' */ './pages/CorporateEventOtherActivitiesPage'
    ),
)
const CorporateEventFlightsPage = loadable(
  () =>
    import(
      /* webpackChunkName: 'CorporateEventFlightsPage' */ './pages/CorporateEventFlightsPage'
    ),
)
const CorporateEventAccommodationPage = loadable(
  () =>
    import(
      /* webpackChunkName: 'CorporateEventAccommodationPage' */ './pages/CorporateEventAccommodationPage'
    ),
)
const CorporateEventThingsToKnowPage = loadable(
  () =>
    import(
      /* webpackChunkName: 'CorporateEventThingsToKnowPage' */ './pages/CorporateEventThingsToKnowPage'
    ),
)
const CorporateEventRegistrationPage = loadable(
  () =>
    import(
      /* webpackChunkName: 'CorporateEventRegistrationPage' */ './pages/CorporateEventRegistrationPage'
    ),
)

function CorporateEventRoutes() {
  const hostname = useAppSelector((state) => state.system.hostname)
  const isCorporateSubdomain = isCorporateEventsHostname(hostname)

  const routeParams = useParams<{ eventId?: string; regionCode?: string }>()
  const eventId = routeParams.eventId || ''
  const regionCode = routeParams.regionCode || ''

  const corporateSubdomainRoutes = (
    <>
      <Route exact path="/:eventId" component={CorporateEventLandingPage} />
      <Route exact path="/:eventId/faq" component={CorporateEventFAQPage} />
      <Route
        exact
        path="/:eventId/other-activities"
        component={CorporateEventOtherActivitiesPage}
      />
      <Route
        exact
        path="/:eventId/flights"
        component={CorporateEventFlightsPage}
      />
      <Route
        exact
        path="/:eventId/accommodation"
        component={CorporateEventAccommodationPage}
      />
      <Route
        exact
        path="/:eventId/things-to-know"
        component={CorporateEventThingsToKnowPage}
      />
      <Route
        exact
        path="/:eventId/register"
        component={CorporateEventRegistrationPage}
      />
    </>
  )

  const mainSiteRoutes = (
    <>
      <Route
        exact
        path="/:regionCode/corporate-events/:eventId"
        component={CorporateEventLandingPage}
      />
      <Route
        exact
        path="/:regionCode/corporate-events/:eventId/faq"
        component={CorporateEventFAQPage}
      />
      <Route
        exact
        path="/:regionCode/corporate-events/:eventId/other-activities"
        component={CorporateEventOtherActivitiesPage}
      />
      <Route
        exact
        path="/:regionCode/corporate-events/:eventId/flights"
        component={CorporateEventFlightsPage}
      />
      <Route
        exact
        path="/:regionCode/corporate-events/:eventId/accommodation"
        component={CorporateEventAccommodationPage}
      />
      <Route
        exact
        path="/:regionCode/corporate-events/:eventId/things-to-know"
        component={CorporateEventThingsToKnowPage}
      />
      <Route
        exact
        path="/:regionCode/corporate-events/:eventId/register"
        component={CorporateEventRegistrationPage}
      />
    </>
  )

  return (
    <CorporateEventLayout eventId={eventId} regionCode={regionCode}>
      <LocaleAwareSwitch>
        {isCorporateSubdomain ? corporateSubdomainRoutes : mainSiteRoutes}
      </LocaleAwareSwitch>
    </CorporateEventLayout>
  )
}

export default CorporateEventRoutes
